import React from 'react';
import { FadeIn } from './FadeIn';
import { ShieldAlert } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="py-10 sm:py-20 px-4 sm:px-6 lg:px-8 bg-white" data-id="element-95">
      <div className="max-w-4xl mx-auto" data-id="element-96">
        <FadeIn data-id="element-97">
          <div className="bg-sage-light/10 rounded-2xl sm:rounded-3xl p-6 sm:p-12 border-2 border-sage border-dashed relative text-center" data-id="element-98">
            <div className="absolute -top-8 sm:-top-10 left-1/2 -translate-x-1/2 bg-white p-3 sm:p-4 rounded-full border-2 border-sage shadow-lg" data-id="element-99">
              <ShieldAlert className="w-8 h-8 sm:w-12 sm:h-12 text-sage-dark" data-id="element-100" />
            </div>

            <h2 className="text-xl sm:text-3xl font-bold text-charcoal mt-4 sm:mt-6 mb-4 sm:mb-6" data-id="element-101">
              Garantía de "Resultados o te Devuelvo hasta el Último Centavo" por
              30 Días.
            </h2>

            <p className="text-sm sm:text-lg text-charcoal-light leading-relaxed mb-4 sm:mb-6" data-id="element-102">
              Prueba el programa. Lee el libro. Aplica las recetas. Si en 30
              días no duermes mejor, no te sientes más ligera o simplemente no
              te gusta el tipo de letra, envíanos un email y te devolvemos el
              100% de tu dinero.
            </p>

            <p className="text-base sm:text-xl font-bold text-sage-dark font-serif italic" data-id="element-103">
              Sin preguntas. El riesgo es todo mío.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}